import * as Datas from "@adminData";
import {axiosPostUtil} from "./axiosUtil";

const api = {
  admin: {
    login: async (params: {id: string; pw: string}) => {
      return await axiosPostUtil<
        Datas.ApiResponse<{
          token: {
            accessToken: string;
            refreshToken: string;
          };
        }>
      >("/api/v1/admin/login", params).then(value => value?.data);
    },

    getAdmin: async () => {
      return await axiosPostUtil<
        Datas.ApiResponse<{
          result: Datas.IAdmin;
          token: {
            accessToken: string;
            refreshToken: string;
          };
        }>
      >("/api/v1/admin/getAdmin").then(value => value?.data);
    },
  },

  review: {
    getList: async ({
      page = 1,
      limit = 20,
      ...args
    }: {
      page?: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IReview[]>>
      >("/api/v1/admin/review/getList", {page, limit, ...args}).then(
        value => value?.data,
      );
    },

    getDetail: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.IReview>>(
        "/api/v1/admin/review/getDetail",
        params,
      ).then(value => value?.data);
    },

    write: async (params: Datas.IReview) => {
      return await axiosPostUtil<Datas.ApiResponse<{no: number}>>(
        "/api/v1/admin/review/write",
        params,
      ).then(value => value?.data);
    },

    edit: async (params: Datas.IReview) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/review/edit",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.ResultPagingResponse>>(
        "/api/v1/admin/review/delete",
        params,
      ).then(value => value?.data);
    },
  },
};

export default api;
